import React from 'react';
import { useTranslation } from 'react-i18next';
import { aboutTranslations } from './about_translation';
import i18n from '../../i18n';

i18n.addResourceBundle('en', 'about', aboutTranslations.en);
i18n.addResourceBundle('fr', 'about', aboutTranslations.fr);

const About = () => {
    const { t } = useTranslation('about');
    const { i18n } = useTranslation();
   // const [currentLanguage, setCurrentLanguage] = useState(i18n.language);


    const toggleLanguage = () => {
        i18n.language === 'en' ? i18n.changeLanguage('fr'):i18n.changeLanguage('en');
    };
  return (
    <div className='flex h-[500px] w-full flex-col justify-center px-[3%] text-xl lg:px-[15%]'>
         <button className='flex-rol flex rounded-full bg-slate-600 px-3 py-2 shadow-md' onClick={() => toggleLanguage()}>toggle language</button>
        <h1>{t('about_us')}</h1>
   </div>
  );
};

export default About;


